module.exports = __webpack_public_path__ + "img/gangster-persona.718e6c38.svg";